import React, { useEffect, useState } from "react";
import TableContainer from "../../components/table/table-container";
import Button from "../../components/buttons/button";
import { useNavigate } from "react-router-dom";
import Pagination from "../../components/pagination/pagination";
import search from "../../assets/icons/searchIcon.svg";
import { useDispatch } from "react-redux";
import { errorToast, successToast } from "../../components/notifications/toast";
import { completeRouteAction, listRouteAction } from "../../redux/actions/routeAction";
import Loader from "../../components/loaders/dot-loader";
import { formatDate, statusColors } from "../../components/helper";

const RoutesList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setSearchValue] = useState('');
    const [debouncedValue, setDebouncedValue] = useState("");
    const [paginationData, setPaginationData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [routes, setRoutes] = useState([]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        console.log("Current Page:", page);
    };

    const handleViewRoute = (routeId) => {
        navigate(`/routes/view/${routeId}`);
    };

    const handleCompleteRoute = (routeId, status) => {
        setLoading(true)
        dispatch(completeRouteAction({ id: routeId, status }, (data) => { successToast(data.data.message); fetchRoutes() }, onError))
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(searchValue);
            setCurrentPage(1)
        }, 300);

        return () => {
            clearTimeout(handler);
        };
    }, [searchValue]);

    useEffect(() => {
        fetchRoutes()
    }, [currentPage, debouncedValue])

    const fetchRoutes = () => {
        setLoading(true)
        dispatch(listRouteAction({ page: currentPage, search: debouncedValue, page_size: 15 }, onSuccess, onError))
    }


    const onSuccess = (data) => {
        setRoutes(data.data.data.routes);
        setPaginationData(data.data.data.pagination)
        setLoading(false)
    }

    const onError = (data) => {
        const errorMsg = data.data.message || "Unable to fetch try later";
        errorToast(errorMsg)
        setLoading(false)
    }

    return (
        <TableContainer>
            <div className="flex flex-col sm:flex-row justify-between px-2 pb-2 w-full">
                <div className="w-full sm:w-auto">
                    <div
                        style={{ height: "2.5rem" }}
                        className={`input_border flex items-center rounded-md w-full sm:w-auto mx-1 md:w-80`}
                    >
                        <span className="px-2">
                            <img width={"16px"} src={search} alt="search icon" />
                        </span>
                        <input
                            placeholder={`Search Routes`}
                            className="table_search_input w-full rounded-md fs_12 placeholder:text-fs_12"
                            type="text"
                            value={searchValue}
                            onChange={(e) => {
                                setSearchValue(e.target.value);
                            }}
                        />
                        <span className="fs_14 mx-3 cursor-pointer text-primary" onClick={() => setSearchValue('')}>Clear</span>
                    </div>
                </div>

                <div className="w-full sm:w-auto mt-2 sm:mt-0">
                    <Button
                        onClick={() => navigate('/routes/create')}
                        variant="primary"
                        size="md"
                        className="w-full sm:w-auto"
                    >
                        Add New Route
                    </Button>
                </div>
            </div>

            <div className="relative">
                <div className="overflow-auto border border-gray-300 rounded-md" style={{ height: '45rem' }}>
                    <table className="w-full border-collapse">
                        <thead>
                            <tr className="bg-gray-100 sticky top-0">
                                <th className="p-2 border border-gray-200 font-medium text-left">#</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">Code</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">Route Name</th>
                                <th className="p-2 border border-gray-200 font-medium ">Total Customers</th>
                                <th className="p-2 border border-gray-200 font-medium text-center">Total Products Sent</th>
                                <th className="p-2 border border-gray-200 font-medium text-center">Total Sold</th>
                                <th className="p-2 border border-gray-200 font-medium text-center">Total Returned</th>
                                <th className="p-2 border border-gray-200 font-medium text-center">Status</th>
                                <th className="p-2 border border-gray-200 font-medium text-center">Created At</th>
                                <th className="p-2 border border-gray-200 font-medium text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="10" style={{ height: '35rem' }}>
                                        <Loader />
                                    </td>
                                </tr>
                            ) : routes.length > 0 ? routes.map((route, index) => (
                                <tr key={route.id} className="hover:bg-gray-50">
                                    <td className="p-2 border border-gray-200">{(currentPage - 1) * paginationData?.pageSize + (index + 1)}</td>
                                    <td className="p-2 border border-gray-200 text-left">{route.code}</td>
                                    <td className="p-2 border border-gray-200 text-left">{route.name}</td>
                                    <td className="p-2 border border-gray-200">
                                        {route.total_customers}
                                    </td>
                                    <td className="p-2 border border-gray-200 text-center">
                                        {route.total_products}
                                    </td>
                                    <td className="p-2 border border-gray-200 text-center">
                                        {route.total_sold ?? "--"}
                                    </td>
                                    <td className="p-2 border border-gray-200 text-center">
                                        {route.total_return ?? "--"}
                                    </td>
                                    <td className="p-3 border border-gray-200"
                                        style={{ color: statusColors.find(item => item.status === route?.status).color }}> {route?.status}
                                    </td>
                                    <td className="p-3 border border-gray-200">{formatDate(route?.createdAt)}</td>
                                    <td className="p-2 border border-gray-200 text-center">
                                        <button
                                            onClick={() => handleViewRoute(route.id)}
                                            className="text-blue-500 hover:underline mx-2"
                                        >
                                            View
                                        </button>

                                        <button
                                            disabled={["COMPLETED", "DISPATCHED"].includes(route.status)}
                                            onClick={() => navigate(`/routes/edit/${route.id}`)}
                                            className={`${["COMPLETED", "DISPATCHED"].includes(route.status) ? "text-blue-200" : "text-primary hover:underline"} mx-1`}
                                        >
                                            Edit
                                        </button>
                                        {route.status === "INITIATED" ?
                                            <button
                                                disabled={["COMPLETED"].includes(route.status)}
                                                onClick={() => handleCompleteRoute(route.id, "DISPATCHED")}
                                                className={`${["COMPLETED"].includes(route.status) ? "text-green-300" : "text-green-500 hover:underline"} mx-2`}
                                            >
                                                Dispatch
                                            </button>
                                            :
                                            <button
                                                disabled={["COMPLETED", "INITIATED"].includes(route.status)}
                                                onClick={() => handleCompleteRoute(route.id, "COMPLETED")}
                                                className={`${["COMPLETED", "INITIATED"].includes(route.status) ? "text-green-300" : "text-green-500 hover:underline"} mx-2`}
                                            >
                                                Complete
                                            </button>
                                        }

                                    </td>
                                </tr>
                            )) :
                                <tr>
                                    <td colSpan="9" style={{ height: '35rem' }}>
                                        <span className="text-gray-400 font-extralight"> No Data Found</span>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="flex justify-end mt-2 bottom-0 right-0">
                <Pagination
                    totalPages={paginationData?.totalPages}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                />
            </div>
        </TableContainer >
    );
};

export default RoutesList;

// Mock Data
const routesData = [
    {
        id: 1,
        name: "Route A",
        totalCustomers: 10,
        totalProductsSent: 100,
        totalSold: 80,
        totalReturned: 20,
    },
    {
        id: 2, name: "Route B",
        totalCustomers: 10,
        totalProductsSent: 100,
        totalSold: 80,
        totalReturned: 20,
    },
    {
        id: 3, name: "Route C",
        totalCustomers: 10,
        totalProductsSent: 100,
        totalSold: 80,
        totalReturned: 20,
    },
    {
        id: 4, name: "Route D",
        totalCustomers: 10,
        totalProductsSent: 100,
        totalSold: 80,
        totalReturned: 20,
    },
    {
        id: 5, name: "Route E",
        totalCustomers: 10,
        totalProductsSent: 100,
        totalSold: 80,
        totalReturned: 20,
    },
];
